import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");

    if (token) {
      document.cookie = `access_token=${token}; path=/; max-age=86400; samesite=lax`;
      navigate({ to: "/" });
    } else {
      navigate({ to: "/login" });
    }
  }, [navigate]);

  return <p>Logging you in...</p>;
}
